module.exports = __webpack_public_path__ + "static/media/lentz_howell.2583ddef.gif";